import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import { AuthCredentials, CustomizedErrorResponse, ErrorReturnType, isErrorReturnType } from "@/types/functions";
import { MeResponse, RegisterCredentials } from "@/types/user";
import { useUserStore } from "@/stores/user";
import { usePersistentStore } from "@/stores/persistent";
import { getPreference } from "@/functions/preferences";
import { customizedErrorResponseHandler, handleAxiosError, isCustomizedErrorResponse } from "@/functions/handler";
import { ReturnStatus } from "@/types/enum/notification";

export function useAuth() {
    const isInvalidRegisterEmail = (response: CustomizedErrorResponse, path: string): response is ErrorReturnType => {
        return path.includes('register') && isErrorReturnType(response) && response.status === ReturnStatus.EMAIL_INVALID
    }

    const authRequest = async (path: string, credentials?: AuthCredentials | RegisterCredentials, options?: AxiosRequestConfig): Promise<AxiosResponse | undefined> => {
        //* Here Axios so that Authorization Header is not used!!
        const response = await axios.post(usePersistentStore().apiUrl + path, credentials, options)
            .catch(handleAxiosError)

        if (isCustomizedErrorResponse(response)) {
            await customizedErrorResponseHandler(response)
            if (isInvalidRegisterEmail(response, path)) throw Error(response.status)
            return undefined
        }

        return response
    }

    const resetPWRequest = async (path: string, credentials?: { email: string }): Promise<boolean> => {
        //* Here Axios so that Authorization Header is not used!!
        const response = await axios.post(usePersistentStore().apiUrl + path, credentials)
            .catch(handleAxiosError)

        if (isCustomizedErrorResponse(response)) {
            await customizedErrorResponseHandler(response)
            return false
        }

        return true
    }

    async function setToken(key: string) {
        const userStore = useUserStore()
        if (!userStore.sessionInfo) userStore.sessionInfo = new MeResponse()
        userStore.sessionInfo.sessionToken = key
    }

    async function getToken() {
        const userStore = useUserStore()
        if (userStore.sessionInfo.sessionToken !== '') {
            return userStore.sessionInfo.sessionToken
        } else {
            const userPref = await getPreference("userStore")

            if (!userPref) return 'error'

            const user = JSON.parse(userPref)

            if (user.sessionInfo.sessionToken) {
                userStore.sessionInfo.sessionToken = user.sessionInfo.sessionToken
                return userStore.sessionInfo.sessionToken
            }
            return 'error'
        }
    }

    return {
        authRequest,
        getToken,
        setToken,
        resetPWRequest
    }
}
